import {
  CoachPaymentKind,
  coachPaymentKindToBgColor,
  coachPaymentKindToLabel,
  coachPaymentKindToTextColor,
} from '@airreading/common/data';

interface CoachPaymentKindTagProps {
  kind: CoachPaymentKind;
}

export const CoachPaymentKindTag = (props: CoachPaymentKindTagProps) => {
  const { kind } = props;

  return (
    <span
      style={{
        backgroundColor: coachPaymentKindToBgColor[kind],
        color: coachPaymentKindToTextColor[kind],
      }}
      className="p-1 rounded-md font-semibold"
    >
      {coachPaymentKindToLabel[kind]}
    </span>
  );
};
